import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeMøteevalueringerKomponent} from "../gruppe-møteevalueringer/gruppe-møteevalueringer";
import {GruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {SpørreundersøkelseListeKomponent} from "../../../spørreundersøkelse/komponenter/spørreundersøkelse-liste/spørreundersøkelse-liste";

const debug = initDebugger('GruppeEvalueringerKomponent');

/** Viser vurderinger for gruppe, dvs spørreundersøkelser og møteevalueringer. */
@Component({
    selector: 'gruppe-evalueringer',
    templateUrl: 'gruppe-evalueringer.html',
    styleUrl: 'gruppe-evalueringer.scss',
    imports: [
        GruppeMøteevalueringerKomponent,
        SpørreundersøkelseListeKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeEvalueringerKomponent {
    static ajsSelector = 'gruppeEvalueringer';

    gruppe = input.required<GruppeModell>();

    constructor() {
    }
}
